import {TableSettings} from '../../../tableSettings';

export const airImportMawbList:TableSettings = {
  tableVersion: 1028,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};

export const airImportHawbList:TableSettings = {
  tableVersion: 10056,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};

export const hawbAiHblPoBodyLineItems:TableSettings = {
  tableVersion: 1014,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '300px',
  flexResizer: true,

  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.59,
    },
    {
      Header: 'PO #',
      accessor: 'poNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 9.48,
    },
    {
      Header: 'SKU',
      accessor: 'skuNo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.93,
    },
    {
      Header: 'HTS Code',
      accessor: 'htsCode',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.62,
    },
    {
      Header: 'C/O',
      accessor: 'coo',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.03,
    },
    {
      Header: 'Description',
      accessor: 'description',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 24.14,
    },
    {
      Header: 'Qty',
      accessor: 'shipQty',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: 'Unit',
      accessor: 'shipUnit',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: 'Unit Price',
      accessor: 'uPrice',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: 'KGS(G)',
      accessor: 'kgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: 'KGS(C)',
      accessor: 'cKgs',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 6.9,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.72,
    },
  ]
};
